import { createTalkingGenerationSessionState } from './createTalkingGenerationSessionState'

export const useAiImageGenerationSessionState =
  createTalkingGenerationSessionState('ai-image')
